import { render, staticRenderFns } from "./SensitiveChanges.vue?vue&type=template&id=a98f378e&scoped=true&"
import script from "./SensitiveChanges.vue?vue&type=script&lang=js&"
export * from "./SensitiveChanges.vue?vue&type=script&lang=js&"
import style0 from "./SensitiveChanges.vue?vue&type=style&index=0&id=a98f378e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98f378e",
  null
  
)

export default component.exports